import React from 'react';
import PropTypes from 'prop-types';
import { pickWithPriority } from 'Helpers/Affordances';
import fr from 'facet-rest';
import AddInsightsButton from './AddInsightsButton';

const AddInsightsButtonPicker = ({
  resource,
  ...rest
}) => {
  return pickWithPriority(resource, [
    [fr.relationships.addInsights.name, <AddInsightsButton resource={resource} {...rest} />],
    [fr.relationships.default.name, null],
  ]);
};

AddInsightsButtonPicker.defaultProps = {
};

AddInsightsButtonPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default AddInsightsButtonPicker;
